import React, { useCallback } from 'react'
import { useParams } from 'react-router'
import { intl } from 'lang/intl'
import { TtButton, TtIcon, TtTooltip } from '@23/react'
import { showNotice } from '../../../../Layout/Notices/Notices'
import { useAddHighlightMutation } from '../hooks/use-highlights'

export const Highlight = () => {
  const params = useParams<{ live_id: string }>()
  const liveId = Number(params.live_id)

  const { mutateAsync: addHighlight } = useAddHighlightMutation(liveId)

  const onClickHandler = useCallback(async () => {
    try {
      await addHighlight()
      showNotice({
        message: intl.formatMessage({
          defaultMessage: 'Highlight has been added',
        }),
        expirationMillis: 2000,
      })
    } catch (e) {
      showNotice({
        message: intl.formatMessage({
          defaultMessage: 'Failed to create highlight. Please try again.',
        }),
        expirationMillis: 2000,
      })
    }
  }, [addHighlight])

  return (
    <TtTooltip
      content={intl.formatMessage({ defaultMessage: 'Add Highlight' })}
      placement="left"
      distance={16}
    >
      <TtButton circle color="secondary" onClick={onClickHandler}>
        <TtIcon name="highlight" library="one/global" />
      </TtButton>
    </TtTooltip>
  )
}
